module.exports = __webpack_public_path__ + "img/21.97329155.jpg";